import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kalyaninagartomumbaitaxi() {



  const cardData = {


  keyword: "Kalyani Nagar to Mumbai Taxi",

  headingDescription: "Trustline Cab provides reliable Kalyani Nagar to Mumbai taxi services with comfortable vehicles, professional drivers, and affordable travel solutions for business trips, airport transfers, corporate meetings, family journeys, and outstation travel. Whether you need a one-way cab or a round-trip taxi, we ensure safe, punctual, and stress-free transportation with well-maintained cars. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to match every travel requirement. With transparent pricing, doorstep pickup, online booking facility, and 24/7 customer support, Trustline Travels is the trusted choice for Kalyani Nagar to Mumbai cab services.",

  topPlaces: [
    {
      title: "Wagle Estate",
      description: "Wagle Estate in Thane is a major industrial and commercial area, hosting corporate offices, manufacturing units, technology companies, and business establishments."
    },
    {
      title: "Belapur CBD",
      description: "Belapur CBD is Navi Mumbai's important commercial district, featuring government offices, banks, corporate headquarters, and business centers."
    },
    {
      title: "Mindspace Airoli",
      description: "Mindspace Airoli is a leading IT and business park known for multinational companies, technology firms, and modern corporate infrastructure."
    },
    {
      title: "TTC Industrial Area",
      description: "TTC Industrial Area is a significant industrial corridor in Navi Mumbai, home to engineering, pharmaceutical, logistics, and manufacturing companies."
    },
    {
      title: "MIDC Marol",
      description: "MIDC Marol is a well-known commercial and industrial zone near Mumbai Airport, housing corporate offices, businesses, and service companies."
    },
    {
      title: "Kamala Mills",
      description: "Kamala Mills is a popular commercial hub in Lower Parel, known for corporate offices, media companies, startups, restaurants, and business spaces."
    },
    {
      title: "Haji Ali Dargah",
      description: "Haji Ali Dargah is a famous spiritual landmark located on an island in the Arabian Sea, admired for its architecture and peaceful atmosphere."
    },
    {
      title: "Kanheri Caves",
      description: "Kanheri Caves are ancient Buddhist rock-cut monuments located inside Sanjay Gandhi National Park, offering historical and cultural experiences."
    },
    {
      title: "Worli Sea Face",
      "description": "Worli Sea Face is a scenic waterfront destination offering beautiful Arabian Sea views and a relaxing atmosphere along Mumbai's coastline."
    },
    {
      title: "Taraporewala Aquarium",
      description: "Taraporewala Aquarium is a popular attraction showcasing diverse marine species and providing an educational experience for visitors of all ages."
    }
  ],





"services": [
  {
    "name": "Kalyani Nagar to Mumbai Taxi",
    "description": "Book Kalyani Nagar to Mumbai taxi for comfortable and reliable intercity travel with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicle options. Enjoy doorstep pickup, professional chauffeurs, transparent pricing, and safe transportation for airport, business, family, and outstation journeys."
  },
  {
    "name": "Kalyani Nagar to Mumbai Taxi Fare",
    "description": "Check Kalyani Nagar to Mumbai taxi fare with affordable and transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV vehicles. Get reliable travel solutions with fixed fares and no hidden charges."
  },
  {
    "name": "Kalyani Nagar to Mumbai Airport Cab",
    "description": "Book Kalyani Nagar to Mumbai Airport cab for smooth airport transfers with timely pickup, luggage assistance, flight tracking, and experienced drivers. Suitable for domestic and international airport travel."
  },
  {
    "name": "Kalyani Nagar to Dadar Cab",
    "description": "Reserve Kalyani Nagar to Dadar cab for railway station transfers, business meetings, and personal travel with comfortable AC vehicles and professional chauffeur service."
  },
  {
    "name": "Kalyani Nagar to Mumbai International Airport Cab",
    "description": "Choose Kalyani Nagar to Mumbai International Airport cab for direct airport transfers to Chhatrapati Shivaji Maharaj International Airport with reliable service and comfortable vehicles."
  },
  {
    "name": "Kalyani Nagar to Mumbai One Day Cab",
    "description": "Book Kalyani Nagar to Mumbai one day cab for business visits, sightseeing, meetings, and personal travel with flexible schedules and experienced drivers."
  },
  {
    "name": "Kalyani Nagar to Mumbai Airport Drop Cab",
    "description": "Get Kalyani Nagar to Mumbai Airport drop cab service with punctual pickup, direct airport routes, luggage support, and affordable pricing for hassle-free travel."
  },
  {
    "name": "Kalyani Nagar to Mumbai Drop Cab",
    "description": "Reliable Kalyani Nagar to Mumbai drop cab for one-way travel with comfortable AC cars, professional chauffeurs, and transparent fares."
  },
  {
    "name": "Taxi Service in Kalyani Nagar Pune",
    "description": "Professional taxi service in Kalyani Nagar Pune for local rides, airport transfers, corporate travel, and outstation journeys with well-maintained vehicles."
  },
  {
    "name": "Cab Service in Kalyani Nagar",
    "description": "Reliable cab service in Kalyani Nagar offering airport transfers, local transportation, employee travel, corporate cabs, and long-distance taxi services."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport cab with direct transfers to domestic and international terminals. Enjoy comfortable AC vehicles, punctual pickup, and professional drivers."
  },
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Choose Pune to Mumbai Ertiga cab for spacious family travel, airport transfers, and group transportation with affordable fares and experienced chauffeurs."
  },
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Premium Pune to Mumbai Innova cab service provides luxury seating, extra luggage space, and comfortable highway travel for families, corporates, and business travelers."
  },
  {
    "name": "Kalyani Nagar to Mumbai Airport Cabs",
    "description": "Book Kalyani Nagar to Mumbai Airport cabs with reliable pickup, flight tracking, clean vehicles, and professional drivers for stress-free airport transfers."
  },
  {
    "name": "Wadgaon Sheri to Mumbai Cabs",
    "description": "Reliable Wadgaon Sheri to Mumbai cabs for airport travel, business trips, family journeys, and outstation transportation with multiple vehicle options."
  },
  {
    "name": "Car Rental Service in Kalyani Nagar",
    "description": "Kalyani Nagar car rental service provides chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury cars for airport transfers, corporate travel, and outstation trips."
  },
  {
    "name": "Cab Service in Yerwada",
    "description": "Professional cab service in Yerwada for local travel, airport pickup and drop, business transportation, and intercity journeys with comfortable vehicles."
  },
  {
    "name": "Pune Mumbai Velocity Cabs",
    "description": "Pune Mumbai Velocity Cabs offers reliable one-way, airport transfer, corporate, and round-trip taxi services with premium vehicles and transparent pricing."
  },
  {
    "name": "Cab Service in Pune",
    "description": "Our cab service in Pune provides local taxi, airport transfers, corporate transportation, and outstation travel with experienced chauffeurs and multiple vehicle options."
  },
  {
    "name": "Pune Mumbai Cab",
    "description": "Reliable Pune Mumbai cab service for airport transfers, business travel, sightseeing, family trips, and one-way or round-trip journeys."
  },
  {
    "name": "Cab Service Kalyani Nagar Pune",
    "description": "Professional cab service in Kalyani Nagar Pune for local rides, airport transfers, corporate travel, and long-distance transportation with affordable pricing."
  },
  {
    "name": "Taxi Service Kalyani Nagar Pune",
    "description": "Trusted taxi service Kalyani Nagar Pune offering safe, comfortable, and affordable transportation with professional drivers and clean AC vehicles."
  },
  {
    "name": "Kalyani Nagar to Mumbai Taxi Service",
    "description": "Book Kalyani Nagar to Mumbai taxi service for safe and convenient travel with Sedan, Ertiga, Innova Crysta, and SUV vehicles available for all travel needs."
  },
  {
    "name": "Kalyani Nagar to Mumbai Cab Service",
    "description": "Choose Kalyani Nagar to Mumbai cab service for airport transfers, corporate trips, family travel, and one-way journeys with transparent pricing."
  },
  {
    "name": "Kalyani Nagar to Mumbai Taxi Booking",
    "description": "Book Kalyani Nagar to Mumbai taxi online with instant confirmation, flexible pickup timing, secure booking, and 24x7 customer support."
  },
  {
    "name": "Cab from Kalyani Nagar to Mumbai",
    "description": "Reserve a cab from Kalyani Nagar to Mumbai for airport transfers, business meetings, sightseeing, and family trips with professional chauffeurs."
  },
  {
    "name": "Kalyani Nagar to Mumbai Car Rental",
    "description": "Kalyani Nagar to Mumbai car rental service offers one-way, round-trip, airport, and corporate travel options with Sedan, Ertiga, Innova Crysta, SUVs, and luxury cars."
  },
  {
    "name": "Kalyani Nagar to Mumbai One Way Taxi",
    "description": "Book Kalyani Nagar to Mumbai one way taxi and pay only for a single journey. Ideal for airport drops, business travel, and personal transportation."
  },
  {
    "name": "Cheap Kalyani Nagar to Mumbai Taxi",
    "description": "Affordable Kalyani Nagar to Mumbai taxi service with comfortable AC vehicles, experienced chauffeurs, transparent pricing, and reliable travel solutions."
  },
  {
    "name": "Book Kalyani Nagar to Mumbai Taxi Online",
    "description": "Book Kalyani Nagar to Mumbai taxi online with instant confirmation, easy reservations, professional drivers, and multiple vehicle choices."
  },
  {
    "name": "Kalyani Nagar to Mumbai Outstation Taxi",
    "description": "Reliable Kalyani Nagar to Mumbai outstation taxi for long-distance travel with experienced drivers, comfortable vehicles, and flexible pickup schedules."
  },
  {
    "name": "Kalyani Nagar to Mumbai Airport Taxi",
    "description": "Reserve Kalyani Nagar to Mumbai Airport taxi for timely airport transfers with flight tracking, luggage assistance, and premium chauffeur-driven vehicles."
  },
  {
    "name": "24x7 Kalyani Nagar to Mumbai Taxi Service",
    "description": "Our 24x7 Kalyani Nagar to Mumbai taxi service is available round the clock for airport transfers, emergency travel, business meetings, and family trips."
  },
  {
    "name": "Best Kalyani Nagar to Mumbai Taxi Service",
    "description": "Experience the best Kalyani Nagar to Mumbai taxi service with premium vehicles, professional chauffeurs, transparent pricing, instant booking, and reliable customer support."
  }
],

"tableData": [
  ["Kalyani Nagar to Mumbai Taxi", "Kalyani Nagar to Mumbai Taxi Fare"],
  ["Kalyani Nagar to Mumbai Airport Cab", "Kalyani Nagar to Dadar Cab"],
  ["Kalyani Nagar to Mumbai International Airport Cab", "Kalyani Nagar to Mumbai One Day Cab"],
  ["Kalyani Nagar to Mumbai Airport Drop Cab", "Kalyani Nagar to Mumbai Drop Cab"],
  ["Taxi Service in Kalyani Nagar Pune", "Cab Service in Kalyani Nagar"],
  ["Pune to Mumbai Airport Cab", "Pune to Mumbai Ertiga Cab"],
  ["Pune to Mumbai Innova Cab", "Kalyani Nagar to Mumbai Airport Cabs"],
  ["Wadgaon Sheri to Mumbai Cabs", "Car Rental Service in Kalyani Nagar"],
  ["Cab Service in Yerwada", "Pune Mumbai Velocity Cabs"],
  ["Cab Service in Pune", "Pune Mumbai Cab"],
  ["Cab Service Kalyani Nagar Pune", "Taxi Service Kalyani Nagar Pune"],
  ["Kalyani Nagar to Mumbai Taxi Service", "Kalyani Nagar to Mumbai Cab Service"],
  ["Kalyani Nagar to Mumbai Taxi Booking", "Cab from Kalyani Nagar to Mumbai"],
  ["Kalyani Nagar to Mumbai Car Rental", "Kalyani Nagar to Mumbai One Way Taxi"],
  ["Cheap Kalyani Nagar to Mumbai Taxi", "Book Kalyani Nagar to Mumbai Taxi Online"],
  ["Kalyani Nagar to Mumbai Outstation Taxi", "Kalyani Nagar to Mumbai Airport Taxi"],
  ["24x7 Kalyani Nagar to Mumbai Taxi Service", "Best Kalyani Nagar to Mumbai Taxi Service"]
],






whychoose: [
  {
    WhyChooseheading: "Premium Kalyani Nagar to Mumbai Taxi Service",
    WhyChoosedescription: "Trustline Cab provides comfortable and reliable taxi services from Kalyani Nagar to Mumbai for airport, business, and personal travel."
  },
  {
    WhyChooseheading: "Pickup from Kalyani Nagar & Nearby Areas",
    WhyChoosedescription: "Enjoy doorstep pickup from Kalyani Nagar, Viman Nagar, Yerawada, Koregaon Park, Wadgaon Sheri, and surrounding locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Routes",
    WhyChoosedescription: "Our professional chauffeurs have excellent route knowledge and ensure a safe journey through Pune-Mumbai highways."
  },
  {
    WhyChooseheading: "Fair & Transparent Taxi Charges",
    WhyChoosedescription: "Get clear fare details before booking with competitive pricing and no unexpected additional costs."
  },
  {
    WhyChooseheading: "Comfortable Cars for Every Need",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for individual or group travel."
  },
  {
    WhyChooseheading: "Airport & Corporate Travel Solutions",
    WhyChoosedescription: "Our taxi services are suitable for Mumbai Airport transfers, corporate meetings, business trips, and personal visits."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Book a one-way taxi or round-trip package according to your travel plan and convenience."
  },
  {
    WhyChooseheading: "24/7 Booking Assistance",
    WhyChoosedescription: "Our support team is available anytime to provide quick quotations and confirm your Kalyani Nagar to Mumbai taxi booking."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Kalyani Nagar to Mumbai taxi service?",
    answer: "Yes, Trustline Cab offers reliable taxi services from Kalyani Nagar to Mumbai for airport transfers, business trips, and personal travel."
  },
  {
    question: "Can I book a one-way taxi from Kalyani Nagar to Mumbai?",
    answer: "Yes, we provide affordable one-way taxi options for passengers who need direct travel to Mumbai."
  },
  {
    question: "Which cars are available for Kalyani Nagar to Mumbai taxi booking?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on passenger requirements."
  },
  {
    question: "Do you provide pickup from nearby Kalyani Nagar locations?",
    answer: "Yes, pickup is available from Kalyani Nagar, Viman Nagar, Koregaon Park, Yerawada, Wadgaon Sheri, and nearby areas."
  },
  {
    question: "Can I book a taxi from Kalyani Nagar to Mumbai Airport?",
    answer: "Yes, we provide direct taxi transfers from Kalyani Nagar to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the booking quotation."
  },
  {
    question: "Is the Kalyani Nagar to Mumbai taxi service available at night?",
    answer: "Yes, Trustline Cab provides taxi services 24 hours a day, including early morning and late-night travel."
  },
  {
    question: "Can I schedule my taxi booking in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and timely pickup."
  },
  {
    question: "Do you offer taxis for corporate travel?",
    answer: "Yes, our taxi services are suitable for corporate professionals traveling between Pune and Mumbai for meetings and official work."
  },
  {
    question: "How can I book a Kalyani Nagar to Mumbai taxi with Trustline Travels?",
    answer: "Share your pickup location, travel date, destination, and preferred vehicle details to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harish Mehta",
    feedback: "Trustline Travels provided a smooth taxi experience from Kalyani Nagar to Mumbai. The driver was professional, the vehicle was comfortable, and the journey was completed on schedule.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "I booked a taxi for my family's Mumbai visit, and Trustline Travels managed everything perfectly. The pickup was punctual, the cab was clean, and the ride was very comfortable.",
    rating: 5
  }
];












  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kalyani Nagar to Mumbai Taxi Service",
  "image": "https://www.trustlinetravels.com/assets/images/kalyani-nagar-to-mumbai-taxi.webp",
  "description": "Book Kalyani Nagar to Mumbai taxi service for safe, comfortable, and affordable intercity travel. Trustline Travels offers one-way, round-trip, and airport taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5738"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/kalyani-nagar-to-mumbai-taxi"
  }
};





  return (
    <div>
<Helmet>
  <title>Kalyani Nagar to Mumbai Taxi | Airport Cab Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Kalyani Nagar to Mumbai taxi service with Trustline Travels for affordable one-way, round-trip, and airport transfers. Get Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs with professional drivers and 24x7 availability."
  />

  <meta
    name="keywords"
    content="kalyani nagar to mumbai taxi fare, kalyani nagar to mumbai airport cab, kalyani nagar to dadar cab, kalyani nagar to mumbai international airport cab, kalyani nagar to mumbai one way cab, kalyani nagar to mumbai taxi service, kalyani nagar to mumbai cab booking, kalyani nagar to mumbai innova cab, kalyani nagar to mumbai ertiga cab, kalyani nagar mumbai airport taxi, pune to mumbai taxi from kalyani nagar, kalyani nagar to mumbai drop taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/42.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kalyaninagartomumbaitaxi;